import { ActionType, NetworkActionPrefix } from '../utils/constants';
import {
    TrendScopeApi, TrendTopicApi, TrendTopicCommentApi, TrendSettingsApi, TrendCategoryApi, TrendTopicTypeApi, BusinessModelAreaApi,
    MarketApi, MarketFreeNodeApi
} from 'for-straction-service-api';
import { networkAPIAction, entityLifecycleActionSet } from '../utils/actionCreatorsFactory';

const trendSettingsActionSet = entityLifecycleActionSet('TrendSettings', 'TREND_SETTINGS', 'trendSettings', TrendSettingsApi, {
    edit: true
});
export const editTrendSettings = (trendSettings, sync) => trendSettingsActionSet.editTrendSettings(trendSettings, sync);
export const syncTrendSettings = (trendSettings) => trendSettingsActionSet.syncTrendSettings(trendSettings);

export const searchTrendSettingsForCurrentCompany = () =>
    networkAPIAction(new TrendSettingsApi(), 'trendSettingsSearchTrendSettingsForCurrentCompanyGet', NetworkActionPrefix.SEARCH_TREND_SETTINGS_FOR_COMPANY_PREFIX, {});


const trendCategoryActionSet = entityLifecycleActionSet('TrendCategory', 'TREND_CATEGORY', 'trendCategory', TrendCategoryApi, {
    loadAll: true
});

export const loadAllTrendCategories = () => trendCategoryActionSet.loadAllTrendCategories();

export const addAllTrendCategories = (trendCategories) =>
    dispatch => {
        dispatch({
            type: ActionType.ADD_ALL_TREND_CATEGORIES,
            trendCategories
        });
        return dispatch(networkAPIAction(new TrendCategoryApi(), 'trendCategoryAddAllPut', NetworkActionPrefix.ADD_ALL_TREND_CATEGORIES_PREFIX,
            { trendCategories }, trendCategories));
    };

export const editAllTrendCategories = (trendCategories) =>
    dispatch => {
        dispatch({
            type: ActionType.EDIT_ALL_TREND_CATEGORIES,
            trendCategories
        });

        dispatch(networkAPIAction(new TrendCategoryApi(), 'trendCategoryEditAllPut', NetworkActionPrefix.EDIT_ALL_TREND_CATEGORIES_PREFIX,
            { trendCategories }, trendCategories));
    };

export const deleteAllTrendCategories = (trendCategoryIDs) =>
    dispatch => {
        dispatch({
            type: ActionType.DELETE_ALL_TREND_CATEGORIES,
            trendCategoryIDs
        });
        dispatch(networkAPIAction(new TrendCategoryApi(), 'trendCategoryDeleteAllPut', NetworkActionPrefix.DELETE_ALL_TREND_CATEGORIES_PREFIX,
            { trendCategoryIDs }, trendCategoryIDs, {}));
    };


const trendScopeActionSet = entityLifecycleActionSet('TrendScope', 'TREND_SCOPE', 'trendScope', TrendScopeApi, {
    loadAll: true
});

export const loadAllTrendScopes = () => trendScopeActionSet.loadAllTrendScopes();

export const editAllTrendScopes = (trendScopes) =>
    dispatch => {
        dispatch({
            type: ActionType.EDIT_ALL_TREND_SCOPES,
            trendScopes
        });

        dispatch(networkAPIAction(new TrendScopeApi(), 'trendScopeEditAllPut', NetworkActionPrefix.EDIT_ALL_TREND_SCOPES_PREFIX,
            { trendScopes }, trendScopes));
    };

const trendTopicActionSet = entityLifecycleActionSet('TrendTopic', 'TREND_TOPIC', 'trendTopic', TrendTopicApi, {
    'loadAll': 'trendTopicLoadReportAllGet',
    'load': 'trendTopicLoadReportGet',
    'add': true,
    'edit': true,
    'delete': true
}, true);
export const loadAllTrendTopics = ({ maxCommentsCount, maxMarketWatchesCount } = {}) => trendTopicActionSet.loadAllTrendTopics({ maxCommentsCount, maxMarketWatchesCount });
export const loadTrendTopic = (trendTopicID, { maxCommentsCount, maxMarketWatchesCount } = {}) => trendTopicActionSet.loadTrendTopic(trendTopicID, { maxCommentsCount, maxMarketWatchesCount });
export const addTrendTopic = (trendTopic, sync, reloadAfterSync) => trendTopicActionSet.addTrendTopic(trendTopic, sync, reloadAfterSync);
export const editTrendTopic = (trendTopic, sync, reloadAfterSync) => trendTopicActionSet.editTrendTopic(trendTopic, sync, reloadAfterSync);
export const syncTrendTopic = (trendTopic) => trendTopicActionSet.syncTrendTopic(trendTopic);
export const removeTrendTopic = (trendTopicID) => trendTopicActionSet.removeTrendTopic(trendTopicID);

export const editAllTrendTopics = (trendTopics) =>
    dispatch => {
        dispatch({
            type: ActionType.EDIT_ALL_TREND_TOPICS,
            trendTopics
        });

        dispatch(networkAPIAction(new TrendTopicApi(), 'trendTopicEditAllPut', NetworkActionPrefix.EDIT_ALL_TREND_TOPICS_PREFIX,
            { trendTopics }, trendTopics));
    };

export const loadTrendComments = (trendTopicID, { startID, maxCount, order } = {}) =>
    networkAPIAction(TrendTopicCommentApi, 'trendTopicCommentSearchSlicePut', NetworkActionPrefix.LOAD_TREND_COMMENTS_PREFIX,
        { trendTopicID }, { TopicID: trendTopicID }, { startID, maxCount, order });

export const editTrendNewComment = (trendTopicID, comment) => ({ type: ActionType.EDIT_TREND_NEW_COMMENT, trendTopicID, comment });

export const loadTrendComment = (trendTopicID, indicatorID) =>
    networkAPIAction(TrendTopicCommentApi, 'trendTopicCommentLoadGet', NetworkActionPrefix.LOAD_TREND_COMMENT_PREFIX, { trendTopicID, trendCommentID }, trendCommentID);

export const addTrendComment = (trendTopicID, comment, sync = false) =>
    dispatch => {
        dispatch({
            type: ActionType.ADD_TREND_COMMENT,
            trendTopicID,
            trendCommentID: comment.ID,
            comment
        });

        if (sync) {
            dispatch(syncTrendComment(trendTopicID, comment));
        }
    };


export const syncTrendComment = (trendTopicID, comment) =>
    networkAPIAction(TrendTopicCommentApi, 'trendTopicCommentAddPut', NetworkActionPrefix.ADD_TREND_COMMENT_PREFIX,
        { trendTopicID, trendCommentID: comment.ID }, comment);


const trendTopicTypeActionSet = entityLifecycleActionSet('TrendTopicType', 'TREND_TOPIC_TYPE', 'trendTopicType', TrendTopicTypeApi, {
    loadAll: true
});
export const loadAllTrendTopicTypes = () => trendTopicTypeActionSet.loadAllTrendTopicTypes();

export const addAllTrendTopicTypes = (trendTopicTypes) =>
    dispatch => {
        dispatch({
            type: ActionType.ADD_ALL_TREND_TOPIC_TYPES,
            trendTopicTypes
        });
        return dispatch(syncNewTrendTopicTypes(trendTopicTypes));
    };

export const syncNewTrendTopicTypes = (trendTopicTypes) =>
    networkAPIAction(new TrendTopicTypeApi(), 'trendTopicTypeAddAllPut', NetworkActionPrefix.ADD_ALL_TREND_TOPIC_TYPES_PREFIX,
        { trendTopicTypes }, trendTopicTypes);

export const editAllTrendTopicTypes = (trendTopicTypes) =>
    dispatch => {
        dispatch({
            type: ActionType.EDIT_ALL_TREND_TOPIC_TYPES,
            trendTopicTypes
        });
        dispatch(syncEditedTrendTopicTypes(trendTopicTypes));
    };

export const syncEditedTrendTopicTypes = (trendTopicTypes) =>
    networkAPIAction(new TrendTopicTypeApi(), 'trendTopicTypeEditAllPut', NetworkActionPrefix.EDIT_ALL_TREND_TOPIC_TYPES_PREFIX,
        { trendTopicTypes }, trendTopicTypes);

export const deleteAllTrendTopicTypes = (trendTopicTypeIDs) =>
    dispatch => {
        dispatch({
            type: ActionType.DELETE_ALL_TREND_TOPIC_TYPES,
            trendTopicTypeIDs
        });
        dispatch(networkAPIAction(new TrendTopicTypeApi(), 'trendTopicTypeDeleteAllPut', NetworkActionPrefix.DELETE_ALL_TREND_TOPIC_TYPES_PREFIX,
            { trendTopicTypeIDs }, trendTopicTypeIDs, {}));
    };

const businessModelAreaActionSet = entityLifecycleActionSet('BusinessModelArea', 'BUSINESS_MODEL_AREA', 'businessModelArea', BusinessModelAreaApi, {
    loadAll: true
});

export const loadAllBusinessModelAreas = () => businessModelAreaActionSet.loadAllBusinessModelAreas();
